module.exports = {"username":"Benutzername","username_placeholder":"Erstelle einen Benutzernamen","username_taken":"Dieser Benutzername ist bereits vergeben","username_taken_long":"Entschuldigen Sie, dieser Benutzername ist bereits vergeben. Versuchen Sie es mit einem anderen.","username_short":"Nicht genügend Zeichen, gib mehr ein","static_hint":"Erlaubte Sonderzeichen: . @ _ -"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/username.json
// module id = 503
// module chunks = 248 1659